import { render, staticRenderFns } from "./NouNouInvoice.vue?vue&type=template&id=3ddfa5a0&scoped=true&"
import script from "./NouNouInvoice.vue?vue&type=script&lang=js&"
export * from "./NouNouInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NouNouInvoice.vue?vue&type=style&index=0&id=3ddfa5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddfa5a0",
  null
  
)

export default component.exports